import {ElementRef, Inject, Injectable, OnDestroy} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import'rxjs/add/observable/from';
import'rxjs/add/observable/fromEvent';
import'rxjs/add/observable/merge';
import'rxjs/add/operator/mergeMap';
import'rxjs/add/operator/takeUntil';
import'rxjs/add/operator/map';
import {WindowService} from './window.service';
export class ScrollbarService implements OnDestroy {
  scrollObs: Observable<number>;
  scrollPos: number;
  childScrolling: boolean;
  scrollSubj: Subject<number> = new Subject();
private _scrollHeight: number;
private ngUnsubscribe: Subject<void> = new Subject();
/**
 * @param {?} ws
 * @param {?} doc
 */
constructor(private ws: WindowService,
private doc: Document) {
    this.scrollObs = Observable.from(this.scrollSubj);
    this.childScrolling = false;
  }
/**
 * @return {?}
 */
get scrollHeight() {
    return this._scrollHeight ? this._scrollHeight : this.doc.documentElement.scrollHeight;
  }
/**
 * @param {?} height
 * @return {?}
 */
set scrollHeight(height: number) {
    this._scrollHeight = height;
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
/**
 * @param {?} el
 * @return {?}
 */
public initWheel(el: HTMLElement): Observable<any> {
    const /** @type {?} */ dommousescroll = Observable.fromEvent(el, 'DOMMouseScroll');
    const /** @type {?} */ mousewheel = Observable.fromEvent(el, 'mousewheel');
    const /** @type {?} */ wheel = Observable.fromEvent(el, 'wheel');

    return Observable.merge(...[dommousescroll, mousewheel, wheel])
      .map((e: WheelEvent) => {
        e.preventDefault();

        const /** @type {?} */ data = {x: 0, y: 0, type: 'wheel'};
        if (e.wheelDelta) {
          data.y = -1 / 40 * e.wheelDelta;
          data.x = e.wheelDeltaX ? -1 / 40 * e.wheelDeltaX : 0;
        } else {
          data.y = e.deltaY || e.detail;
        }
        return data;
      });
  }
/**
 * @param {?} el
 * @param {?} bar
 * @return {?}
 */
public initDrag(el: HTMLElement, bar: HTMLElement):
  { start: Observable<any>, end: Observable<any>, move: Observable<any> } {
    let /** @type {?} */ observs;

    const /** @type {?} */ mousemove = Observable.fromEvent(this.ws.window, 'mousemove');
    const /** @type {?} */ mousedown = Observable.fromEvent(bar, 'mousedown');
    const /** @type {?} */ mouseup = Observable.fromEvent(this.ws.window, 'mouseup');

    const /** @type {?} */ mousedrag = mousedown.mergeMap((e: MouseEvent) => {
      const /** @type {?} */ pageY = e.pageY;
      const /** @type {?} */ top = parseFloat(getComputedStyle(bar).top);

      return mousemove.map((emove: MouseEvent) => {
        emove.preventDefault();
        return top + emove.pageY - pageY;
      }).takeUntil(mouseup);
    });

    observs = {
      start: mousedrag,
      end: mouseup,
      move: mousemove
    };

    if (this.ws.isMobile) {
      const /** @type {?} */ touchmove = Observable.fromEvent(this.ws.window, 'touchmove');
      const /** @type {?} */ touchstart = Observable.fromEvent(el, 'touchstart');
      const /** @type {?} */ touchend = Observable.fromEvent(this.ws.window, 'touchend');

      const /** @type {?} */ touchdrag = touchstart.mergeMap((e: TouchEvent) => {
        const /** @type {?} */ pageY = e.targetTouches[0].pageY;
        const /** @type {?} */ top = -parseFloat(getComputedStyle(bar).top);

        return touchmove.map((tmove: TouchEvent) => {
          return -(top + tmove.targetTouches[0].pageY - pageY);
        }).takeUntil(touchend);
      });

      observs = {
        start: Observable.merge(...[mousedrag, touchdrag]),
        end: Observable.merge(...[mouseup, touchend]),
        move: Observable.merge(...[mousemove, touchstart])
      };
    }

    return observs;
  }
/**
 * Get an elements distance in pixels from the top
 * 
 * @param {?} el
 * @return {?}
 */
public getElOffsetTop(el: ElementRef): number {
    const /** @type {?} */ viewportTop = el.nativeElement.getBoundingClientRect().top;
    const /** @type {?} */ clientTop = el.nativeElement.clientTop;

    return viewportTop + this.scrollPos - clientTop;

  }
/**
 * Get an elements distance in pixels from the bottom
 * 
 * @param {?} el
 * @return {?}
 */
public getElOffsetBottom(el: ElementRef): number {
    const /** @type {?} */ viewportTop = el.nativeElement.getBoundingClientRect().top;
    const /** @type {?} */ clientBottom = el.nativeElement.clientTop + el.nativeElement.clientHeight;

    return viewportTop + this.scrollPos - clientBottom;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: WindowService, },
{type: Document, decorators: [{ type: Inject, args: [DOCUMENT, ] }, ]},
];
}

function ScrollbarService_tsickle_Closure_declarations() {
/** @type {?} */
ScrollbarService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ScrollbarService.ctorParameters;
/** @type {?} */
ScrollbarService.prototype.scrollObs;
/** @type {?} */
ScrollbarService.prototype.scrollPos;
/** @type {?} */
ScrollbarService.prototype.childScrolling;
/** @type {?} */
ScrollbarService.prototype.scrollSubj;
/** @type {?} */
ScrollbarService.prototype._scrollHeight;
/** @type {?} */
ScrollbarService.prototype.ngUnsubscribe;
/** @type {?} */
ScrollbarService.prototype.ws;
/** @type {?} */
ScrollbarService.prototype.doc;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
